import React, { useEffect, useState } from 'react';
import { eq } from 'lodash';
import { ui, uiA, uiAlert, uiView, uiInputText, uiFormRow, uiCheckbox, uiButton, uiCard, CheckboxWrapper, OverlayScroll } from 'envy-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery, useMutation } from '@apollo/client';
import moment from 'moment';

import {
  CLIENT_STATE,
  GENERAL_SETTINGS,
  CREATE_UNPUBLISH_DATA,
  CREATE_PUBLISH_DATA,
  CREATE_PREVIEW_DATA,
  SET_CLIENT_STATE,
} from '../../../graphqls';
import getUserId from '../../../util/getUserId';

export default function PreviewPublish() {
  const [key, setKey] = useState('');
  const [expiredAt, setExpiredAt] = useState('');
  const [embedCodeType, setEmbedCode] = useState('embedCodeWithoutBranding');
  const { loading: loadingState, data: { sideMenu } = {} } = useQuery(CLIENT_STATE);
  const { loading: loadingSetting, data: { generalSettings: { publishedAt, unpublishedAt, customSubDomain } = {} } = {} } =
    useQuery(GENERAL_SETTINGS);
  const [createUnpublishData] = useMutation(CREATE_UNPUBLISH_DATA, {
    refetchQueries: [{ query: GENERAL_SETTINGS }],
  });
  const [createPublishData] = useMutation(CREATE_PUBLISH_DATA, {
    refetchQueries: [{ query: GENERAL_SETTINGS }],
  });
  const [createPreviewData] = useMutation(CREATE_PREVIEW_DATA, {
    onCompleted: ({ createPreviewData: previewInfo = {} }) => {
      setKey(previewInfo.key);
      setExpiredAt(previewInfo.expiredAt);
    },
  });
  const [setState] = useMutation(SET_CLIENT_STATE);

  useEffect(() => {
    if (!eq(sideMenu, 'PreviewPublishDropdown')) {
      setKey('');
      setExpiredAt('');
    }
  }, [sideMenu]);

  const lastPublishDate = publishedAt ? moment(publishedAt).format('MMM D, YYYY, h:mm:ss a') : 'Never';
  const lastUnpublishDate = unpublishedAt ? moment(unpublishedAt).format('MMM D, YYYY, h:mm:ss a') : 'Never';
  const noBrandPreviewUrl = `//${window.location.host}/preview-brandoff/${key}`;
  const withBrandPreviewUrl = `//${window.location.host}/preview/${key}`;
  const noBrandPublishUrl = `//${window.location.host}/dashboard-brandoff/${customSubDomain}`;
  const withBrandPublishUrl = `//${window.location.host}/dashboard/${customSubDomain}`;
  const onClose = () => setState({ variables: { sideMenu: '', showPreviewLinks: false } });
  const onPreview = () => createPreviewData();
  const onPublish = () => {
    const userId = getUserId(window.userId);
    if (!userId) {
      return console.error('userId should exist');
    }
    createPublishData({ variables: { userId } });
  };
  const onUnpublish = () => {
    const userId = getUserId(window.userId);
    if (!userId) {
      return console.error('userId should exist');
    }
    createUnpublishData({ variables: { userId } });
  };
  const dateText = !eq(lastUnpublishDate, 'Never') ? 'Unpublish Date' : 'Publish Date';
  const publishUnpublishDate = !eq(lastUnpublishDate, 'Never') ? lastUnpublishDate : lastPublishDate;
  const publishStatus = !eq(lastPublishDate, 'Never') ? 'Published' : 'Unpublished';
  const onToggleEmbedCode = () => {
    if (embedCodeType === 'embedCodeWithoutBranding') {
      setEmbedCode('embedCodeWithBranding');
    } else {
      setEmbedCode('embedCodeWithoutBranding');
    }
  }
  if (loadingState || loadingSetting || !eq(sideMenu, 'PreviewPublishDropdown')) {
    return '';
  }
  const embedCode = {
    embedCodeWithBranding:
      `<div style="postion:relative;padding:0% 0 0;overflow:hidden"><iframe src="https://${window.location.host}/dashboard/${customSubDomain}" style="border-width:0;overflow:hidden;width:100%;height:100%;position:absolute"></iframe></div>`,
     embedCodeWithoutBranding:
      `<div style="postion:relative;padding:0% 0 0;overflow:hidden"><iframe src="https://${window.location.host}/dashboard-brandoff/${customSubDomain}" style="border-width:0;overflow:hidden;width:100%;height:100%;position:absolute"></iframe></div>`,
  }
    
  return (
    <div className="main-settings-container">
      <div className="main-settings-view">
        <div className="main-settings-spacer" />
        <div {...ui([uiView``, uiA`f w-100% border-left-panel color-bg-white`])}>
          <div {...ui([uiView`__header`, uiA`m-bottom`])}>
            <span {...ui([uiView`__header-title`, uiA`m-right-auto color-default`])}>Preview and Publish</span>
            <button onClick={onClose} type="button" {...ui([uiButton`--clean --content-gray`, uiA`m-right`])}>
              <span {...ui([uiButton`__content`])}>
                <FontAwesomeIcon icon={['fal', 'times']} />
              </span>
            </button>
          </div>
          <div {...ui([uiView`__main-wrapper1`])}>
            <div {...ui([uiView`__main-wrapper2`, uiA`overflow-x-hidden`])}>
              <div {...ui([uiView`__main`, uiA`f-a-start f-gap p-x`])}>
                {expiredAt && key ? (
                  <div {...ui(uiA`f f-column w-100% f-a-start f-gap`)}>
                    <a href={withBrandPreviewUrl} target="_blank" rel="noopener noreferrer" {...ui([uiButton`--light-blue`, uiA`m-top`])}>
                      <span {...ui([uiButton`__content`, uiA`f f-gap`])}>
                        <span>Preview with Branding</span>
                        <FontAwesomeIcon icon={['fal', 'external-link']} {...ui([uiA`opacity-7`])}/>
                      </span>
                    </a>
                    <a href={noBrandPreviewUrl} target="_blank" rel="noopener noreferrer" {...ui([uiButton`--light-blue`, uiA`m-bottom`])}>
                      <span {...ui([uiButton`__content`, uiA`f f-gap`])}>
                        <span>Preview without Branding</span>
                        <FontAwesomeIcon icon={['fal', 'external-link']} {...ui([uiA`opacity-7`])}/>
                      </span>
                    </a>
                  </div>
                ) : (
                  <button type="button" onClick={onPreview} {...ui([uiButton`--light-blue`, uiA`m-y`])}>
                    <span {...ui([uiButton`__content`, uiA`f f-gap-small`])}>
                      Generate Preview
                    </span>
                  </button>
                )}
                <span {...ui([uiA`w-300 h-1 h-min-1 border-top-light m-x- m-bottom-small`])} />
                <div {...ui(uiA`f f-column f-a-start f-gap w-100%`)}>
                    {eq(publishStatus, 'Published') && (
                      <div {...ui([uiAlert`--warning`, uiA`f font-size-14 f-gap-small m-bottom w-100%`])}>
                        <FontAwesomeIcon icon={['fal', 'globe']} />
                        <span {...ui([uiA`semibold`])}>{`${publishStatus}: ${lastPublishDate}`}</span>
                      </div>
                    )}
                    {eq(publishStatus, 'Unpublished') && !eq(publishUnpublishDate, 'Never') && (
                      <div {...ui([uiA`font-color-medium-gray`])}>
                        {`${dateText}: ${publishUnpublishDate}`}
                      </div>
                    )}
                    {eq(publishStatus, 'Unpublished') && eq(publishUnpublishDate, 'Never') && (
                      <div {...ui([uiA`font-color-medium-gray`])}>
                        Unpublished
                      </div>
                    )}
                  <div {...ui([uiA`f f-gap`])}>
                    <button type="button" onClick={onPublish} {...ui([uiButton`--mint-blue`])}>
                      <span {...ui([uiButton`__content`, uiA`f f-gap-small`])}>
                        <FontAwesomeIcon icon={['fal', 'globe']} />
                        Publish
                      </span>
                    </button>
                    {!eq(lastPublishDate, 'Never') && (
                      <button type="button" onClick={onUnpublish} {...ui([uiButton`--default`])}>
                        <span {...ui([uiButton`__content`, uiA`f f-gap-small`])}>
                          Unpublish
                        </span>
                      </button>
                    )}
                  </div>
                  {!eq(lastPublishDate, 'Never') ? (
                    <>
                      <div {...ui([uiFormRow`--column --full`, uiA`f f-column m-top m-bottom-none`])}>
                        <span {...ui([uiFormRow`__label`, uiA`ellipsis color-default`])}>Published URL <span {...ui([uiA`semibold`])}>with Branding</span></span>
                        <div {...ui([uiA`f w-100%`])}>
                          <input value={withBrandPublishUrl} readOnly {...ui([uiInputText`--stack-left`, uiA`ellipsis f-1-1-200`])} />
                          <a href={withBrandPublishUrl} target="_blank" rel="noopener noreferrer" {...ui([uiButton`--default --menu-right`])}>
                            <span {...ui([uiButton`__content`, uiA`border-left-panel`])}>
                              <FontAwesomeIcon icon={['fal', 'external-link']} {...ui([uiA`color-brand-blue`])}/>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div {...ui([uiFormRow`--column --full`, uiA`f f-column`])}>
                        <span {...ui([uiFormRow`__label`, uiA`ellipsis color-default`])}>Published URL <span {...ui([uiA`semibold`])}>without Branding</span></span>
                        <div {...ui([uiA`f w-100%`])}>
                          <input value={noBrandPublishUrl} readOnly {...ui([uiInputText`--stack-left`, uiA`ellipsis f-1-1-200`])} />
                          <a href={noBrandPublishUrl} target="_blank" rel="noopener noreferrer" {...ui([uiButton`--default --menu-right`])}>
                            <span {...ui([uiButton`__content`, uiA`border-left-panel`])}>
                              <FontAwesomeIcon icon={['fal', 'external-link']} {...ui([uiA`color-brand-blue`])}/>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div {...ui([uiA`f f-column w-100%`])}>
                        <label {...ui([uiFormRow`--full --column`, uiA`m-bottom-none`])}>
                          <span {...ui([uiFormRow`__label`, uiA`f f-gap-small f-a-center font-weight-normal`])}><span>Embed Code</span><FontAwesomeIcon icon={['fal', 'code']} /></span>
                          <a
                            href="/"
                            className="form-control"
                            id="embedCode"
                            style={{
                              width: '1px',
                              height: '1px',
                              borderWidth: 0,
                              overflow: 'hidden',
                              margin: 0,
                              padding: 0,
                            }}
                          >
                            {embedCode[embedCodeType]}
                          </a>
                          <textarea
                            value={embedCode[embedCodeType]}
                            readOnly
                            {...ui([
                              uiInputText``,
                              uiA`h-min-125 h-max-200 w-100% w-min-200 font-weight-normal`,
                            ])}
                          />
                        </label>
                        <button
                          type="button"
                          onClick={() => {
                            const clipboard = document.createRange();
                            const embedCode = document.querySelector('#embedCode');
                            clipboard.selectNode(embedCode);
                            window.getSelection().removeAllRanges();
                            window.getSelection().addRange(clipboard);
                            document.execCommand('copy');
                            window.getSelection().removeAllRanges();
                          }}
                          {...ui([uiButton`--clean --content-link --small --round`, uiA`f f-gap-small m-left-auto m-top-3`])}
                        >
                          <span {...ui([uiButton`__content`, uiA`f f-gap-small`])}>
                            <FontAwesomeIcon icon={['fal', 'copy']} />
                            <span>Copy to Clipboard</span>
                          </span>
                        </button>
                      </div>
                      <label {...ui([uiFormRow``, uiA`w-100% m-top-5- f-gap`])}>
                        <input
                          type="checkbox"
                          checked={embedCodeType === 'embedCodeWithBranding'}
                          onChange={onToggleEmbedCode}
                          {...ui([uiCheckbox`--toggle`, uiA``])}
                        />
                        <span {...ui([uiFormRow`__label`, uiA`p-right nowrap font-weight-normal`])}>Embed Code with Branding</span>

                      </label>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
